import { Region } from '../Shared/Region';
import { EffectTypes } from '../../Enums/EffectTypes';
import { BaseEffect } from './BaseEffect';
import { type VisualCompElement } from '../../types';

export class ClipEffect extends BaseEffect {
    static type = EffectTypes.CLIP;

    static getRegionOfDefinition(region: Region, compElement: VisualCompElement) {
        return region;
    }

    static getRegionOfInterest(region: Region, compElement: VisualCompElement) {
        //TODO: Implement intersection calculation between clip path and region.
        return region;
    }
}
